<template>
  <div class="billManagement app-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/inventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>货物</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px">
        <div class="formItemBox">
        <el-form-item label="盘库状态:">
          <el-select v-model="formData.inventoryDetailStatus" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in inventoryDetailStatusData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库时间:">
          <div style="display: flex;">
          <el-date-picker v-model="formData.inventoryTimeStart" size="mini" type="datetime" placeholder="请选择盘库时间"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          -
          <el-date-picker v-model="formData.inventoryTimeEnd" size="mini" placeholder="请选择盘库时间" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="仓位名称:">
          <el-input v-model="formData.warehouseName" size="mini" placeholder="请选择仓位名"></el-input>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable
            size="mini">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
              :value="item.productType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择"
            filterable size="mini">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择"
            filterable size="mini">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[9]">导出</el-button>

        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="actualNumber" label="实际件数" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryDetailStatus" label="盘库状态" align="center">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.inventoryDetailStatus==0">未盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==1">已盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==2">盘库新增</span>
          </template> -->
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位名称" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryPerson" label="盘库人" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTime" label="盘库时间" align="center" width="200">
        </el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="200">
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template v-slot='scope'>
            <el-button type="text" @click="tupian(scope.row)">图片</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
        <div>
          <div class="img_box" v-for="(item,index) in imgData" :key="index">
            <el-image :src="item.url" :preview-src-list="imgList" class="tupian"></el-image>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  zidianKuwei, // 字典库位
  getInventoryJFGoodsList,
  getImgShow,
  getVirtualBalingList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import {
  exportExcel
} from '@/utils/fileDown.js'
export default {
  data () {
    return {
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      btnArr: [
        '003P01wB001',
        '003P01wB002',
        '003P01wB003',
        '003P01wB004',
        '003P01wB005',
        '003P01wB006',
        '003P010100',
        '003P010200',
        '003P010400',
        '003P010500'
      ],
      tableData: [],
      formData: {
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: '',
        warehouseName: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      },
      addKuwei: [],
      productTypeData: [],
      steelMillNameData: [],
      specificationData: [],
      modelData: [],
      inventoryDetailStatusData: [{
        id: '1',
        name: '已盘'
      },
      {
        id: '0',
        name: '未盘'
      },
      {
        id: '2',
        name: '盘库新增'
      }
      ],
      total: 0,
      addMarkLookBox: false,
      imgData: [],
      btnFlg: this.$route.query.btnFlg,
      id: this.$route.query.inventoryMasterId,

      inventoryMasterId: '',
      imgList: [],
      h: '500px'
    }
  },
  created () {
    this.zidianKuweiS()
    this.chaxun()
    this.getVirtualBalingList()
    // this.btnFlg = getBtn(this.btnArr)
    console.log(this.btnFlg, 'btnFlg')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 210 + 'px'
  },
  methods: {
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportJCGoodsList', {
          ...this.formData,
          inventoryMasterId: this.id
        },
        '货物详情表'
      )
    },
    getInventoryJFGoodsList () {
      let productTypeName
      if (this.formData.productType == '') {
        productTypeName = ''
      } else {
        productTypeName = this.productTypeData.filter(item => item.productType == this.formData.productType)[0]
          .productTypeName
      }
      getInventoryJFGoodsList({
        inventoryMasterId: this.$route.query.inventoryMasterId,
        ...this.formData,
        productTypeName,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryJFGoodsList()
    },
    chongzhi () {
      this.formData = {
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: '',
        warehouseName: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      }
      this.chaxun()
      this.getVirtualBalingList()
    },
    tupian (row) {
      this.addMarkLookBox = true
      getImgShow({
        businessId: row.inventoryDetailId,
        businessType: 'inventory_picture'
      }).then(res => {
        console.log(res)
        this.imgData = res
        this.imgList = res.map(item => item.url)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    margin-top: 15px;

    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .addMarkBox {
    .noImg {
      text-align: center;
    }
  }

  .img_box {
    width: 150px;
    height: 200px;
    display: inline-block;
    margin-right: 20px;
    border: 1px dashed #ccc;
    padding: 5px;

    .tupian {
      width: 100%;
      height: 100%;
    }
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
